<template>
    <div v-if="element && element.style && element.style.customCss" v-html="'<style>' + element.style.customCss + '</style>'"></div>
    <div class="element-wrapper pb-callout" :class="[element.props.themeStyle, element.id + 'wrap']" v-if="element.props" @click.stop="onClick()" :style="element.props.themeStyle ? '' : styleObject">
        <template v-if="element.props.imagePosition === 'AboveHeading' || element.props.imagePosition === 'BelowHeading'">
            <!-- Image Above -->
            <div :style="imgWrapperStyle" v-if="element.props.image !== '' && element.props.imagePosition === 'AboveHeading'">
                <img :style="imgStyleObject" :src="element.props.image" class="callout-image" />
            </div>
            <!-- Heading  -->
            <h1 :style="headingStyle" class="callout-heading" v-if="element.props.headingTag == 'h1'" :class="element.class">{{ element.props.heading ? element.props.heading : "Add your heading text" }}</h1>
            <h2 :style="headingStyle" class="callout-heading" v-if="element.props.headingTag == 'h2'" :class="element.class">{{ element.props.heading ? element.props.heading : "Add your heading text" }}</h2>
            <h3 :style="headingStyle" class="callout-heading" v-if="element.props.headingTag == 'h3'" :class="element.class">{{ element.props.heading ? element.props.heading : "Add your heading text" }}</h3>
            <h4 :style="headingStyle" class="callout-heading" v-if="element.props.headingTag == 'h4'" :class="element.class">{{ element.props.heading ? element.props.heading : "Add your heading text" }}</h4>
            <h5 :style="headingStyle" class="callout-heading" v-if="element.props.headingTag == 'h5'" :class="element.class">{{ element.props.heading ? element.props.heading : "Add your heading text" }}</h5>
            <h6 :style="headingStyle" class="callout-heading" v-if="element.props.headingTag == 'h6'" :class="element.class">{{ element.props.heading ? element.props.heading : "Add your heading text" }}</h6>
            <!-- Image Below -->
            <div :style="imgWrapperStyle" v-if="element.props.image !== '' && element.props.imagePosition === 'BelowHeading'">
                <img :style="element.props.themeStyle ? '' : imgStyleObject" :src="element.props.image" class="callout-image" />
            </div>
            <!-- Text -->
            <div class="callout-text" :style="element.props.themeStyle ? '' : textStyle" v-html="element.props.text"></div>
        </template>

        <div v-else class="row" :style="rowStyle">
            <div class="col-6" v-if="element.props.imagePosition === 'LeftOfTextAndHeading'">
                <!-- Image -->
                <div :style="imgWrapperStyle" v-if="element.props.image !== ''">
                    <img :style="element.props.themeStyle ? '' : imgStyleObject" :src="element.props.image" class="callout-image" />
                </div>
            </div>
            <div class="col-6" v-if="element.props.imagePosition === 'LeftOfTextAndHeading'">
                <!-- Heading  -->
                <h1 :style="headingStyle" class="callout-heading" v-if="element.props.headingTag == 'h1'" :class="element.class">{{ element.props.heading ? element.props.heading : "Add your heading text" }}</h1>
                <h2 :style="headingStyle" class="callout-heading" v-if="element.props.headingTag == 'h2'" :class="element.class">{{ element.props.heading ? element.props.heading : "Add your heading text" }}</h2>
                <h3 :style="headingStyle" class="callout-heading" v-if="element.props.headingTag == 'h3'" :class="element.class">{{ element.props.heading ? element.props.heading : "Add your heading text" }}</h3>
                <h4 :style="headingStyle" class="callout-heading" v-if="element.props.headingTag == 'h4'" :class="element.class">{{ element.props.heading ? element.props.heading : "Add your heading text" }}</h4>
                <h5 :style="headingStyle" class="callout-heading" v-if="element.props.headingTag == 'h5'" :class="element.class">{{ element.props.heading ? element.props.heading : "Add your heading text" }}</h5>
                <h6 :style="headingStyle" class="callout-heading" v-if="element.props.headingTag == 'h6'" :class="element.class">{{ element.props.heading ? element.props.heading : "Add your heading text" }}</h6>
                <!-- Text -->
                <div class="callout-text" :style="element.props.themeStyle ? '' : textStyle" v-html="element.props.text"></div>
            </div>
            <div class="col-6" v-if="element.props.imagePosition === 'RightOfTextAndHeading'">
                <!-- Heading  -->
                <h1 :style="headingStyle" class="callout-heading" v-if="element.props.headingTag == 'h1'" :class="element.class">{{ element.props.heading ? element.props.heading : "Add your heading text" }}</h1>
                <h2 :style="headingStyle" class="callout-heading" v-if="element.props.headingTag == 'h2'" :class="element.class">{{ element.props.heading ? element.props.heading : "Add your heading text" }}</h2>
                <h3 :style="headingStyle" class="callout-heading" v-if="element.props.headingTag == 'h3'" :class="element.class">{{ element.props.heading ? element.props.heading : "Add your heading text" }}</h3>
                <h4 :style="headingStyle" class="callout-heading" v-if="element.props.headingTag == 'h4'" :class="element.class">{{ element.props.heading ? element.props.heading : "Add your heading text" }}</h4>
                <h5 :style="headingStyle" class="callout-heading" v-if="element.props.headingTag == 'h5'" :class="element.class">{{ element.props.heading ? element.props.heading : "Add your heading text" }}</h5>
                <h6 :style="headingStyle" class="callout-heading" v-if="element.props.headingTag == 'h6'" :class="element.class">{{ element.props.heading ? element.props.heading : "Add your heading text" }}</h6>
                <!-- Text -->
                <div class="callout-text" :style="element.props.themeStyle ? '' : textStyle" v-html="element.props.text"></div>
            </div>
            <div class="col-6" v-if="element.props.imagePosition === 'RightOfTextAndHeading'">
                <!-- Image -->
                <div :style="imgWrapperStyle" v-if="element.props.image !== ''">
                    <img :style="element.props.themeStyle ? '' : imgStyleObject" :src="element.props.image" class="callout-image" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Callout",
    props: {
        element: {
            required: true,
            type: Object,
        },
    },
    methods: {
        onClick() {
            this.$emit("onClick", this.element);
        },
        checkInputValue(value) {
            if (value && value != "0px" && value != "0%" && value != "0rem") {
                return true;
            } else {
                return false;
            }
        },

        checkTwoValuesReturn(first, second) {
            if (this.checkInputValue(first)) {
                return first;
            } else if (this.checkInputValue(second)) {
                return second;
            } else {
                return "auto";
            }
        },
    },
    computed: {
        styleObject() {
            const s = this.element.style;
            return {
                width: s.width && s.width != "0%" && s.width != "0px" && s.width != "0rem" ? s.width : "auto",
                backgroundColor: s.backgroundColor,
                color: s.color,
                padding: s.padding,
                margin: s.margin,
                borderRadius: s.borderRadius,
                ...(s.border && String(s.border).trim() !== "" ? { border: s.border } : {}),
            };
        },
        headingStyle() {
            return {
                textAlign: this.element.style.headingTextAlign ? this.element.style.headingTextAlign : "left",
                padding: this.element.style.headingPadding ? this.element.style.headingPadding : "auto",
                color: this.element.style.headingColor ? this.element.style.headingColor : "",
            };
        },
        textStyle() {
            return {
                padding: this.element.style.textPadding ? this.element.style.textPadding : "auto",
                color: this.element.style.textColor ? this.element.style.textColor : "",
            };
        },
        imgStyleObject() {
            const s = this.element.style;
            return {
                width: this.checkInputValue(s.fitWidth) ? s.fitWidth : "auto",
                height: this.checkInputValue(s.fitHeight) ? s.fitHeight : "auto",
                borderRadius: s.imageBorderRadius,
                objectFit: s.objectFit && s.objectFit !== "none" ? s.objectFit : "cover",
                ...(s.imageBorder && String(s.imageBorder).trim() !== "" ? { border: s.imageBorder } : {}),
            };
        },
        imgWrapperStyle() {
            return {
                textAlign: this.element.style.imageAlign,
            };
        },
        rowStyle() {
            return {
                ...(this.element.style.contentVerticalAlign ? { alignItems: this.element.style.contentVerticalAlign } : {}),
            };
        },
    },
    emits: ["onClick"],
};
</script>
